<script>
  import ChannelInfo from './ChannelInfo.vue'
  import ApplicationConfig from './ApplicationConfig.vue'

  export default {
    name: 'EditChannelCode',
    inject: ['flag'],
    components: {
      ChannelInfo,
      ApplicationConfig
    },
    props: {
      // 应用端配置的限制
      limits: {
        type: Object,
        default: () => ({
          wechat: -1, // -1表示不限制
          alipay: -1,
          douyin: -1,
          app: -1
        })
      },
      // 关闭前的确认
      needConfirmBeforeClose: {
        type: Boolean,
        default: true
      },
      editData: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        activeTab: 'channelInfo', // 当前激活的选项卡
        localValue: {
          channelInfo: {
            name: '',
            address: '',
            email: '',
            phone: '',
            fristOrder: 0,
            admin: '',
            remark: '',
            commondOrder: 0,
            validityHours: 72,
            type: this.flag
          },
          applications: {
            wechat: [],
            alipay: [],
            douyin: [],
            app: []
          }
        },
        hasModified: false, // 是否已修改
        tabs: [
          { name: 'channelInfo', label: '渠道信息' },
          { name: 'applications', label: '应用端' }
        ],
        infoEditNo: 0,
        clientEditNo: 0
      }
    },
    created() {
      if (Object.keys(this.editData).length > 0) {
        this.localValue = this.editData
      }
    },
    computed: {
      isEdit() {
        const { channelInfo } = this.localValue
        const { id } = channelInfo
        return id || id === 0
      }
    },
    watch: {
      'localValue.channelInfo': {
        handler() {
          this.infoEditNo += 1
        },
        deep: true
      },
      'localValue.applications': {
        handler() {
          this.clientEditNo += 1
        },
        deep: true
      }
    },
    methods: {
      // 切换标签
      handleTabClick(tab) {
        if (tab.name === 'channelInfo') {
          if (this.isEdit) {
            if (this.clientEditNo > 1) {
              this.confirmFunc().then((res) => {
                if (res) {
                  this.activeTab = tab.name
                }
              })
            } else {
              this.activeTab = tab.name
            }
          } else {
            if (this.clientEditNo > 0) {
              this.confirmFunc().then((res) => {
                if (res) {
                  this.activeTab = tab.name
                }
              })
            } else {
              this.activeTab = tab.name
            }
          }
        } else if (tab.name === 'applications') {
          if (this.isEdit) {
            if (this.infoEditNo > 1) {
              this.confirmFunc().then((res) => {
                if (res) {
                  this.activeTab = tab.name
                }
              })
            } else {
              this.activeTab = tab.name
            }
          } else {
            if (this.infoEditNo > 0) {
              this.confirmFunc().then((res) => {
                if (res) {
                  this.activeTab = tab.name
                }
              })
            } else {
              this.activeTab = tab.name
            }
          }
        }
      },

      // 关闭前确认
      confirmBeforeClose() {
        if (!this.needConfirmBeforeClose) {
          return Promise.resolve(true)
        }

        // 编辑的情况
        if (this.isEdit) {
          if (this.infoEditNo > 1 || this.clientEditNo > 1) {
            return this.confirmFunc()
          } else {
            return Promise.resolve(true)
          }
        } else {
          if (this.infoEditNo > 0 || this.clientEditNo > 0) {
            return this.confirmFunc()
          } else {
            return Promise.resolve(true)
          }
        }
      },

      confirmFunc() {
        return new Promise((resolve) => {
          this.$confirm('当前页面信息未保存，是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              resolve(true)
            })
            .catch(() => {
              resolve(false)
            })
        })
      },

      // 验证表单
      validate() {
        return new Promise((resolve, reject) => {
          // if (this.activeTab === 'channelInfo' && this.$refs.channelInfo) {
          //   return this.$refs.channelInfo.validate();
          // }
          // return Promise.resolve(true);
          const promiseList = [
            this.$refs.applicationConfig.validate(),
            this.$refs.channelInfo.validate()
          ]
          Promise.all(promiseList).then((results) => {
            const isValid = results.every((valid) => valid)
            if (isValid) {
              resolve(this.localValue)
            }
          })
        })
      },

      // 重置表单
      reset() {
        if (this.activeTab === 'channelInfo' && this.$refs.channelInfo) {
          this.$refs.channelInfo.resetForm()
        }
        this.hasModified = false
      }
    }
  }
</script>

<template>
  <div class="edit-channel-code">
    <!-- 选项卡 -->
    <div class="tabs-header">
      <div
        v-for="tab in tabs"
        :key="tab.name"
        class="tab-item"
        :class="{ active: activeTab === tab.name }"
        @click="handleTabClick(tab)"
      >
        {{ tab.label }}
      </div>
      <div class="tab-line"></div>
    </div>

    <!-- 内容区域 -->
    <div class="tab-content">
      <!-- 渠道信息 -->
      <div v-show="activeTab === 'channelInfo'" class="tab-pane">
        <ChannelInfo ref="channelInfo" v-model="localValue.channelInfo" />
      </div>

      <!-- 应用端 -->
      <div v-show="activeTab === 'applications'" class="tab-pane">
        <ApplicationConfig
          ref="applicationConfig"
          v-model="localValue.applications"
          :limits="limits"
          :isEdit="isEdit"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .edit-channel-code {
    background-color: #fff;
    border-radius: 4px;

    .tabs-header {
      display: flex;
      position: relative;
      border-bottom: 1px solid #e4e7ed;

      .tab-item {
        padding: 0 20px;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        cursor: pointer;
        transition: color 0.3s;
        position: relative;

        &.active {
          color: #409eff;
        }

        &.active::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 2px;
          background-color: #409eff;
        }
      }

      .tab-line {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 2px;
        background-color: #409eff;
        transition: transform 0.3s;
      }
    }

    .tab-content {
      min-height: 300px;

      .tab-pane {
        padding: 0 20px;
      }
    }
  }
</style>
